module.exports = __webpack_public_path__ + "static/images/phone-2.svg";